import { render } from "./JoinDistributorPageSvg.vue?vue&type=template&id=30461d40"
const script = {}

import exportComponent from "/codebuild/output/src17432379/src/orprio-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__